/* Scrollbase commerce kit (generated by Scrollbase): buy boxes, sticky add to cart, galleries, carousels, videos, tabs, accordions and reviews for page parts, through data-sb-* attributes. */
(() => {
'use strict';
if (window.SBCommerce) { window.SBCommerce.init(); return; }
const doc = document;
const reduced = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
const behavior = reduced ? 'auto' : 'smooth';
const groups = {};
const all = (root, sel) => Array.prototype.slice.call(root.querySelectorAll(sel));
const attr = (el, name) => el.getAttribute(name);
const show = (el, on) => { el.hidden = !on; };
const flag = (el, name, on) => { if (on) el.setAttribute(name, ''); else el.removeAttribute(name); };
const setText = (el, value) => { if (el.textContent.replace(/\d*?|[]/g, '') !== value) el.textContent = value; };
const firstOf = (list, test) => { for (let k = 0; k < list.length; k++) if (test(list[k], k)) return k; return -1; };
const readJson = (el) => {
if (!el) return null;
if (!('_sbJson' in el)) { try { el._sbJson = JSON.parse(el.textContent); } catch (e) { el._sbJson = null; } }
return el._sbJson;
};
const ours = (el) => { const s = el.closest('[data-sb-section]'); return !s || attr(s, 'data-sb-section').indexOf('sbx-') === 0; };
const once = (el, kind) => { const k = '_sb' + kind; if (el[k]) return false; el[k] = true; return true; };
const throttle = (fn, ms) => { let t = 0; return () => { if (!t) t = setTimeout(() => { t = 0; fn(); }, ms); }; };
const debounce = (fn, ms) => { let t = 0; return () => { clearTimeout(t); t = setTimeout(fn, ms); }; };
const words = (el, name, tokens) => {
let s = attr(el, name);
if (!s) return null;
Object.keys(tokens || {}).forEach((k) => { s = s.split('[' + k + ']').join(tokens[k]); });
return s;
};
const onScreen = (el) => { const r = el.getBoundingClientRect(); return (r.width > 0 || r.height > 0) && r.bottom > 0 && r.top < innerHeight; };
const click = (els, fn) => els.forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); fn(b); }));
const FORMATS = {
amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
amount_with_apostrophe_separator: [2, "'", '.'], amount_with_space_separator: [2, ' ', ','],
amount_no_decimals_with_space_separator: [0, ' ', ','], amount_with_period_and_space_separator: [2, ' ', '.']
};
const DEFAULT_FORMAT = '$' + '{{amount}}';
let shopFormat;
const plain = (html) => { const t = doc.createElement('textarea'); t.innerHTML = String(html).replace(/<[^>]*>/g, ''); return t.value.trim(); };
const moneyFormat = (el) => {
const own = el && el.closest('[data-sb-money-format]');
if (own && attr(own, 'data-sb-money-format')) return plain(attr(own, 'data-sb-money-format')) || DEFAULT_FORMAT;
if (shopFormat === undefined) {
const shop = readJson(doc.querySelector('script[data-sb-shop]'));
shopFormat = shop && shop.money_format ? plain(shop.money_format) : '';
}
return shopFormat || DEFAULT_FORMAT;
};
const money = (cents, format) => {
cents = Math.round(Number(cents) || 0);
return String(format || DEFAULT_FORMAT).replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
const trim = /_trim$/.test(key), f = FORMATS[key.replace(/_trim$/, '')] || FORMATS.amount;
const parts = (Math.abs(cents) / 100).toFixed(f[0]).split('.');
return (cents < 0 ? '-' : '') + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, f[1]) + (parts[1] && !(trim && /^0+$/.test(parts[1])) ? f[2] + parts[1] : '');
});
};
const cash = (el, cents, fmt) => {
const old = el.querySelector('.money');
if (!old) return setText(el, money(cents, fmt));
if (el._sbCents === undefined) { el._sbCents = cents; return; }
if (el._sbCents === cents) return;
el._sbCents = cents;
const n = doc.createElement('span');
n.className = 'money';
n.textContent = money(cents, fmt);
old.replaceWith(n);
};
const paint = (els, v, fmt, units) => {
const sale = !!v && v.compare_at_price > v.price;
const off = sale ? v.compare_at_price - v.price : 0, pct = sale ? Math.round(off * 100 / v.compare_at_price) : 0;
els.price.forEach((el) => { if (els.own) show(el, !!v); if (v) cash(el, v.price, fmt); });
els.compare.forEach((el) => { show(el, sale); if (sale) cash(el, v.compare_at_price, fmt); });
els.save.forEach((el) => {
const percent = String(attr(el, els.saveAttr) || '').trim() === 'percent', has = percent ? pct >= 1 : off > 0;
show(el, has);
if (!has) return;
const a = money(off, fmt), p = pct + '%';
setText(el, words(el, 'data-sb-save-label', { amount: a, percent: p }) || (percent ? p : a));
});
els.unit.forEach((el) => {
const has = !!v && units > 0;
show(el, has);
if (has) { const a = money(v.price / units, fmt); setText(el, words(el, 'data-sb-unit-label', { amount: a }) || a); }
});
};
const priceEls = (find, prefix) => ({ price: find('[data-sb-' + prefix + 'price]'), compare: find('[data-sb-' + prefix + 'compare]'), save: find('[data-sb-' + prefix + 'save]'), saveAttr: 'data-sb-' + prefix + 'save', unit: find('[data-sb-' + prefix + 'unit-price]'), own: !!prefix });
const productOf = (s) => { const p = readJson(s); return p && Array.isArray(p.variants) ? p : null; };
const pageProduct = (form) => {
const pid = form.querySelector('[name="product-id"]'), vid = form.querySelector('[name="id"]');
return all(doc, 'script[data-sb-product]').map(productOf).filter((p) => p && ((pid && String(p.id) === pid.value) || (vid && p.variants.some((v) => String(v.id) === vid.value))))[0] || null;
};
const STATE_WORDS = { available: 'data-sb-add-label', soldout: 'data-sb-soldout-label', unavailable: 'data-sb-unavailable-label' };
const buy = (form) => {
if (!once(form, 'Buy')) return;
const part = form.closest('[data-sb-section]');
let product = null, js = null;
for (let el = form; el && el.nodeType === 1; el = el.parentElement) {
js = el.querySelector('script[data-sb-product]');
if (js) { product = productOf(js); break; }
if (el === part || el === doc.body) break;
}
const h = js && !product && readJson(js);
if (typeof h === 'string') {
fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + encodeURIComponent(h) + '.js').then((r) => r.json()).then((p) => { js._sbJson = p; form._sbBuy = 0; buy(form); });
return;
}
if (!product) product = pageProduct(form);
const scope = part || form;
form._sbScope = scope;
const variants = product ? product.variants : [];
const n = product ? Math.max(1, (product.options || []).length) : 0;
const opts = (v) => (v.options && v.options.length ? v.options : [v.option1, v.option2, v.option3]).slice(0, n);
const find = (sel) => variants.filter((v) => opts(v).every((o, i) => o === sel[i]))[0] || null;
const byId = (id) => (id ? variants.filter((v) => String(v.id) === String(id))[0] || null : null);
const canBuy = (i, val) => variants.some((x) => x.available && opts(x)[i] === val);
const mine = (sel, inChoices) => all(scope, sel).filter((x) => {
const f = x.closest('form[data-sb-buy]');
return (!f || f === form) && (inChoices || !x.closest('[data-sb-value],[data-sb-plan]'));
});
const idInput = form.querySelector('[name="id"]');
const adds = form._sbAdds = mine('[data-sb-add]');
adds.forEach((b) => { if (!b.disabled) b._sbLabel = (b.querySelector('[data-sb-add-text]') || b).textContent.trim(); });
const optionGroups = mine('[data-sb-option]').map((g, k) => {
const p = parseInt(attr(g, 'data-sb-option'), 10);
return { el: g, i: (p >= 1 && p <= 3 ? p : k + 1) - 1 };
});
const selectOf = (g) => (g.tagName === 'SELECT' ? g : g.querySelector('select'));
const choices = (g) => {
const sel = selectOf(g);
if (sel) return all(sel, 'option');
return all(g, '[data-sb-value]').concat(all(g, 'input[type="radio"]').filter((r) => !r.closest('[data-sb-value]')));
};
const valueOf = (c) => (c.hasAttribute('data-sb-value') ? attr(c, 'data-sb-value') : c.value);
const radioOf = (c) => (c.matches('input') ? c : c.querySelector('input[type="radio"]'));
const picked = (g) => {
const sel = selectOf(g);
if (sel) return sel.value;
const c = choices(g).filter((x) => {
const r = radioOf(x);
return r ? r.checked : attr(x, 'aria-pressed') === 'true' || attr(x, 'aria-checked') === 'true' || x.hasAttribute('data-selected') || x.classList.contains('is-selected');
})[0];
return c ? valueOf(c) : null;
};
const unitsFor = (sel) => {
for (let k = 0; k < optionGroups.length; k++) {
const g = optionGroups[k], c = choices(g.el).filter((x) => valueOf(x) === sel[g.i] && x.hasAttribute('data-sb-units'))[0];
if (c) return parseFloat(attr(c, 'data-sb-units')) || 0;
}
return 0;
};
const planInput = form.querySelector('[data-sb-plan-input]') || form.querySelector('[name="selling_plan"]');
const planChoices = mine('[data-sb-plans]').reduce((list, g) => list.concat(all(g, '[data-sb-plan]')), []);
const planOf = (c) => attr(c, 'data-sb-plan') || '';
const planVariant = (c) => byId(attr(c, 'data-sb-plan-variant'));
const allocation = (v, plan) => (v && plan ? (v.selling_plan_allocations || []).filter((a) => String(a.selling_plan_id) === String(plan))[0] || null : null);
const onPlan = (v, plan) => {
if (!v || !plan) return v;
const a = allocation(v, plan);
return a ? Object.assign({}, v, { price: a.price, compare_at_price: Math.max(a.compare_at_price || 0, v.compare_at_price || 0, v.price) }) : null;
};
const isOn = (c) => { const r = radioOf(c); return r ? r.checked : attr(c, 'aria-pressed') === 'true' || attr(c, 'aria-checked') === 'true' || c.hasAttribute('data-selected') || c.classList.contains('is-selected'); };
const markChoice = (c, on) => {
const radio = radioOf(c), role = attr(c, 'role');
if (radio) radio.checked = on;
if (role === 'radio' || role === 'menuitemradio') c.setAttribute('aria-checked', on);
else if (role === 'option' || role === 'tab') c.setAttribute('aria-selected', on);
else if (c.tagName === 'BUTTON' || role === 'button') c.setAttribute('aria-pressed', on);
c.classList.toggle('is-selected', on);
flag(c, 'data-selected', on);
};
let qty = mine('[data-sb-qty]')[0] || null;
let sent = qty && qty.form !== form ? null : qty;
if (sent !== qty && qty.form && !qty.form.hasAttribute('data-sb-buy')) qty.removeAttribute('name');
const minus = mine('[data-sb-qty-minus]'), plus = mine('[data-sb-qty-plus]');
const bounds = () => [Math.max(1, parseInt(qty && attr(qty, 'min'), 10) || 1), parseInt(qty && attr(qty, 'max'), 10) || Infinity];
const qtyNow = () => { if (!qty) return 1; const b = bounds(), q = parseInt(qty.value, 10); return Math.min(b[1], Math.max(b[0], isNaN(q) ? b[0] : q)); };
const ctl = { form: form, sel: [], variant: null, plan: '', shown: null };
if (product) (groups[product.id] = groups[product.id] || []).push(ctl);
const peers = () => (product ? (groups[product.id] = groups[product.id].filter((c) => c.form.isConnected)) : [ctl]);
const totals = () => {
if (!variants.length) return;
const v = ctl.shown || ctl.variant, ok = !!(v && v.available), fmt = moneyFormat(form);
mine('[data-sb-total]').forEach((x) => { show(x, ok); if (ok) setText(x, money(v.price * qtyNow(), fmt)); });
};
const setQty = ctl.setQty = (q, sync) => {
if (!sent) {
if (!qty && q === 1) return;
sent = doc.createElement('input');
sent.type = 'hidden';
sent.name = 'quantity';
form.appendChild(sent);
}
if (!qty) qty = sent;
qty.value = q;
if (sent !== qty) sent.value = q;
const b = bounds();
minus.forEach((x) => { x.disabled = q <= b[0]; });
plus.forEach((x) => { x.disabled = q >= b[1]; });
totals();
if (sync) peers().forEach((c) => { if (c !== ctl) c.setQty(q, false); });
};
const apply = ctl.apply = (next, user) => {
const sel = ctl.sel = next.slice();
const v = ctl.variant = find(sel);
if (ctl.plan && v && !allocation(v, ctl.plan)) ctl.plan = product && product.requires_selling_plan ? String(((v.selling_plan_allocations || [])[0] || {}).selling_plan_id || '') : '';
const shown = ctl.shown = onPlan(v, ctl.plan) || v;
const ok = !!(v && v.available), state = !v ? 'unavailable' : ok ? 'available' : 'soldout';
const fmt = moneyFormat(form);
optionGroups.forEach((g) => {
const i = g.i, select = selectOf(g.el), soldLabel = attr(g.el, 'data-sb-soldout-label') || (select && attr(select, 'data-sb-soldout-label'));
choices(g.el).forEach((c) => {
const val = valueOf(c), on = val === sel[i];
const test = sel.slice();
test[i] = val;
const match = find(test);
const any = canBuy(i, val), sold = any && !(match && match.available);
const radio = radioOf(c), role = attr(c, 'role');
if (c.tagName === 'OPTION') {
c.selected = on;
if (c._sbText == null) c._sbText = c.textContent;
setText(c, soldLabel && (sold || !any) ? c._sbText + ' - ' + soldLabel : c._sbText);
} else if (radio) radio.checked = on;
if (role === 'radio' || role === 'menuitemradio') c.setAttribute('aria-checked', on);
else if (role === 'option' || role === 'tab') c.setAttribute('aria-selected', on);
else if (c.tagName === 'BUTTON' || role === 'button') c.setAttribute('aria-pressed', on);
c.classList.toggle('is-selected', on);
flag(c, 'data-selected', on);
flag(c, 'data-soldout', sold);
flag(c, 'data-unavailable', !any);
if (radio) radio.disabled = !any;
if (c !== radio) {
if (c.tagName === 'BUTTON' || c.tagName === 'OPTION') c.disabled = !any;
else if (role) c.setAttribute('aria-disabled', String(!any));
}
if (c.tagName !== 'OPTION') paint(priceEls((s) => all(c, s), 'value-'), match, fmt, parseFloat(attr(c, 'data-sb-units')) || 0);
});
});
paint(priceEls(mine, ''), shown, fmt, unitsFor(sel));
mine('[data-sb-variant-title]').forEach((x) => setText(x, v && v.title !== 'Default Title' ? v.title : ''));
mine('[data-sb-option-value]').forEach((x) => setText(x, sel[(parseInt(attr(x, 'data-sb-option-value'), 10) || 1) - 1] || ''));
form.setAttribute('data-sb-state', state);
if (scope !== form) scope.setAttribute('data-sb-state', state);
const label = (x, own) => attr(x, own) || (state === 'unavailable' ? attr(x, STATE_WORDS.soldout) : null);
adds.forEach((b) => {
b.disabled = !ok;
const w = label(b, STATE_WORDS[state]) || (ok ? b._sbLabel : null);
if (w) setText(b.querySelector('[data-sb-add-text]') || b, w);
});
mine('[data-sb-stock]').forEach((x) => {
x.setAttribute('data-state', state);
const w = label(x, ok ? 'data-sb-stock-label' : STATE_WORDS[state]);
show(x, !!w);
if (w) setText(x, w);
});
mine('[data-sb-express]').forEach((x) => show(x, ok));
if (idInput) {
const id = v ? String(v.id) : '';
if (idInput.value !== id) { idInput.value = id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
}
if (planInput) {
if (planInput.value !== ctl.plan) { planInput.value = ctl.plan; planInput.dispatchEvent(new Event('change', { bubbles: true })); }
planInput.disabled = !ctl.plan;
}
planChoices.forEach((c) => {
const want = attr(c, 'data-sb-plan-variant'), plan = planOf(c), priced = onPlan(planVariant(c) || v, plan);
markChoice(c, plan === ctl.plan && (!want || (!!v && String(v.id) === want)));
flag(c, 'data-unavailable', !priced || !priced.available);
paint(priceEls((s) => all(c, s), 'plan-'), priced, fmt, parseFloat(attr(c, 'data-sb-units')) || 0);
const days = parseFloat(attr(c, 'data-sb-plan-days')) || 0;
all(c, '[data-sb-plan-per-day]').forEach((el) => {
show(el, !!priced && days > 0);
if (priced && days > 0) { const a = money(priced.price / days, fmt); setText(el, words(el, 'data-sb-per-day-label', { amount: a }) || a); }
});
});
totals();
if (!user) return;
if (v) {
all(doc, '[data-sb-gallery]').forEach((g) => { if (g._sbToVariant) g._sbToVariant(v); });
if (/^https?:$/.test(location.protocol) && window.history && history.replaceState && (location.pathname.indexOf('/products/' + product.handle) !== -1 || form.hasAttribute('data-sb-update-url'))) {
try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.href); } catch (e) {}
}
}
form.dispatchEvent(new CustomEvent('sb:variant-change', { bubbles: true, detail: { variant: v, product: product } }));
};
const choose = (i, val) => {
if (ctl.sel[i] === val) return;
const next = ctl.sel.slice();
next[i] = val;
peers().forEach((c) => { if (c !== ctl) c.apply(next, false); });
apply(next, true);
};
optionGroups.forEach((g) => {
g.el.addEventListener('click', (e) => {
const c = selectOf(g.el) ? null : e.target.closest('[data-sb-value]');
if (!c || !g.el.contains(c) || radioOf(c)) return;
e.preventDefault();
if (!c.hasAttribute('data-unavailable')) choose(g.i, valueOf(c));
});
g.el.addEventListener('keydown', (e) => {
if (e.key !== 'Enter' && e.key !== ' ') return;
const c = selectOf(g.el) ? null : e.target.closest('[data-sb-value]');
if (!c || !g.el.contains(c) || radioOf(c) || c.tagName === 'BUTTON') return;
e.preventDefault();
if (!c.hasAttribute('data-unavailable')) choose(g.i, valueOf(c));
});
g.el.addEventListener('change', (e) => {
const t = e.target;
if (t.tagName === 'SELECT') choose(g.i, t.value);
else if (t.type === 'radio' && t.checked) { const c = t.closest('[data-sb-value]'); choose(g.i, c && g.el.contains(c) ? valueOf(c) : t.value); }
});
});
const pickPlan = (c) => {
if (c.hasAttribute('data-unavailable')) return;
const plan = planOf(c), target = planVariant(c), next = target ? opts(target) : ctl.sel.slice();
peers().forEach((p) => { p.plan = plan; if (p !== ctl) p.apply(next, false); });
apply(next, true);
};
planChoices.forEach((c) => {
const radio = radioOf(c);
if (radio) { radio.addEventListener('change', () => { if (radio.checked) pickPlan(c); }); return; }
c.addEventListener('click', (e) => { e.preventDefault(); pickPlan(c); });
c.addEventListener('keydown', (e) => {
if ((e.key !== 'Enter' && e.key !== ' ') || c.tagName === 'BUTTON') return;
e.preventDefault();
pickPlan(c);
});
});
const step = (d) => () => { const b = bounds(); setQty(Math.min(b[1], Math.max(b[0], qtyNow() + d)), true); };
click(minus, step(-1));
click(plus, step(1));
if (qty) qty.addEventListener('change', () => setQty(qtyNow(), true));
const reset = form._sbReset = () => {
form._sbBusy = false;
adds.forEach((b) => { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
};
form.addEventListener('submit', (e) => {
if ((variants.length && (!idInput || !idInput.value)) || form._sbBusy) { e.preventDefault(); return; }
setTimeout(() => {
if (e.defaultPrevented) return;
form._sbBusy = true;
adds.forEach((b) => { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
setTimeout(reset, 8000);
}, 0);
});
if (variants.length) {
const start = byId(idInput && idInput.value) || byId(new URLSearchParams(location.search).get('variant'));
const live = peers().filter((c) => c !== ctl && c.sel.length)[0];
const printed = planChoices.filter(isOn)[0];
ctl.plan = live ? live.plan : printed ? planOf(printed) : planInput && !planInput.disabled ? planInput.value : '';
const pe = mine('[data-sb-price]')[0], first = onPlan(start, ctl.plan) || start;
if (pe && first) {
const f = moneyFormat(form), m = money(first.price, f), t = pe.textContent.trim(), k = t.indexOf(m);
const ft = f.replace(/\{\{\s*(\w+)\s*\}\}/, '{{$1_trim}}'), mt = money(first.price, ft), kt = k < 0 && mt !== m ? t.indexOf(mt) : -1;
if (k >= 0 && t !== m) form.setAttribute('data-sb-money-format', t.slice(0, k) + f + t.slice(k + m.length));
else if (kt >= 0) form.setAttribute('data-sb-money-format', t.slice(0, kt) + ft + t.slice(kt + mt.length));
}
let sel;
if (live) sel = live.sel.slice();
else if (start) sel = opts(start);
else {
sel = opts(variants.filter((v) => v.available)[0] || variants[0]);
optionGroups.forEach((g) => { const p = picked(g.el); if (p != null) sel[g.i] = p; });
}
apply(sel, false);
}
if (qty) setQty(qtyNow(), false);
};
const mainForm = () => {
const forms = all(doc, 'form[data-sb-buy]').filter((f) => ours(f) && !f.closest('[data-sb-sticky]'));
return forms.filter((f) => { const r = attr(f, 'data-sb-buy'); return !r || r === 'main'; })[0] || forms[0] || null;
};
const footerOf = () => doc.querySelector('[data-sb-sticky-stop]') ||
all(doc, '.shopify-section-group-footer-group, #shopify-section-footer, [data-sb-section="sb-footer"], .sb-landing-foot, footer')
.filter((el) => !el.closest('[data-sb-sticky]') && (el.matches('[data-sb-section]') || !el.closest('[data-sb-section]')))[0] || null;
const sticky = (bar) => {
if (!once(bar, 'Sticky')) return;
const always = attr(bar, 'data-sb-sticky') === 'always';
const phone = window.matchMedia ? matchMedia('(max-width: 749px)') : null;
const io = 'IntersectionObserver' in window ? new IntersectionObserver(() => run()) : null;
const watched = [];
let shown = null;
const set = (on) => {
if (on === shown) return;
shown = on;
bar.classList.toggle('is-visible', on);
bar.setAttribute('aria-hidden', on ? 'false' : 'true');
flag(bar, 'inert', !on);
};
const check = () => {
if (!bar.isConnected) { stop(); return; }
const f = mainForm();
const main = f && ((f._sbAdds && f._sbAdds[0]) || f.querySelector('[data-sb-add]'));
const adds = all(doc, '[data-sb-add]').filter((b) => !b.closest('[data-sb-sticky]') && ours(b));
const footer = footerOf();
[main, footer].concat(adds).forEach((x) => { if (io && x && watched.indexOf(x) < 0) { io.observe(x); watched.push(x); } });
const passed = main ? main.getBoundingClientRect().bottom < 0 : window.scrollY > innerHeight;
const end = !!footer && footer.getBoundingClientRect().top < innerHeight;
set((always || !phone || phone.matches) && passed && !end && !adds.some(onScreen));
};
const run = throttle(check, 50);
const stop = () => {
window.removeEventListener('scroll', run);
window.removeEventListener('resize', run);
if (io) io.disconnect();
};
window.addEventListener('scroll', run, { passive: true });
window.addEventListener('resize', run);
if (phone) { if (phone.addEventListener) phone.addEventListener('change', run); else if (phone.addListener) phone.addListener(run); }
click(all(bar, '[data-sb-sticky-scroll]'), () => {
const f = mainForm();
if (!f) return;
const box = f._sbScope && f._sbScope.getBoundingClientRect().height < innerHeight * 0.9 ? f._sbScope : f;
box.scrollIntoView({ behavior: behavior, block: box.getBoundingClientRect().height < innerHeight * 0.8 ? 'center' : 'start' });
});
set(false);
check();
};
const fileOf = (src) => String(src || '').split('?')[0].split('/').pop();
const gallery = (g) => {
if (!once(g, 'Gallery')) return;
const track = g.querySelector('[data-sb-track]');
if (!track) return;
track._sbGallery = true;
const slides = all(track, '[data-sb-slide]');
const thumbs = all(g, '[data-sb-thumb]'), dots = all(g, '[data-sb-dot]');
if (!g.querySelector('[data-sb-prev],[data-sb-next]') && slides.length > 1 && window.matchMedia && matchMedia('(hover:hover)').matches) {
const box = track.parentElement;
if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
['prev', 'next'].forEach((d) => {
const b = document.createElement('button');
b.type = 'button';
b.className = 'sb-g-arrow sb-g-' + d;
b.setAttribute('data-sb-' + d, '');
b.setAttribute('aria-label', d === 'prev' ? 'Previous picture' : 'Next picture');
b.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="' + (d === 'prev' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6') + '"/></svg>';
box.appendChild(b);
});
}
const prev = all(g, '[data-sb-prev]'), next = all(g, '[data-sb-next]');
const indexOf = (el, k, name) => { const x = parseInt(attr(el, name), 10); return isNaN(x) ? k : x; };
let active = -1;
const mark = (i) => {
if (i === active) return;
active = i;
g.setAttribute('data-sb-active', String(i));
slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
[[thumbs, 'data-sb-thumb'], [dots, 'data-sb-dot']].forEach((pair) => pair[0].forEach((el, k) => {
const on = indexOf(el, k, pair[1]) === i;
el.classList.toggle('is-active', on);
if (on) el.setAttribute('aria-current', 'true'); else el.removeAttribute('aria-current');
}));
prev.forEach((b) => { b.disabled = i <= 0; });
next.forEach((b) => { b.disabled = i >= slides.length - 1; });
const t = thumbs[firstOf(thumbs, (el, k) => indexOf(el, k, 'data-sb-thumb') === i)], strip = t && t.parentElement;
if (!strip) return;
const tr = t.getBoundingClientRect(), sr = strip.getBoundingClientRect();
if (strip.scrollWidth > strip.clientWidth) strip.scrollLeft += tr.left + tr.width / 2 - (sr.left + sr.width / 2);
if (strip.scrollHeight > strip.clientHeight) strip.scrollTop += tr.top + tr.height / 2 - (sr.top + sr.height / 2);
};
const go = (i, jump) => {
i = Math.max(0, Math.min(slides.length - 1, i));
const s = slides[i];
if (!s) return;
const pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
track.scrollTo({ left: track.scrollLeft + s.getBoundingClientRect().left - track.getBoundingClientRect().left - pad, behavior: jump && Math.abs(i - active) > 1 ? 'auto' : behavior });
mark(i);
};
const settle = debounce(() => {
const tr = track.getBoundingClientRect();
let best = 0, most = -1;
slides.forEach((s, k) => {
const r = s.getBoundingClientRect(), seen = r.width ? Math.max(0, Math.min(r.right, tr.right) - Math.max(r.left, tr.left)) / r.width : 0;
if (seen > most + 0.01) { most = seen; best = k; }
});
mark(best);
}, 80);
if ('IntersectionObserver' in window) {
const io = new IntersectionObserver(settle, { root: track, threshold: [0.25, 0.5, 0.75, 1] });
slides.forEach((s) => io.observe(s));
}
track.addEventListener('scroll', settle, { passive: true });
thumbs.forEach((t, k) => click([t], () => go(indexOf(t, k, 'data-sb-thumb'))));
dots.forEach((d, k) => click([d], () => go(indexOf(d, k, 'data-sb-dot'))));
click(prev, () => go(active - 1));
click(next, () => go(active + 1));
g._sbToVariant = (v) => {
const media = v.featured_media && v.featured_media.id, img = v.featured_image;
const vs = all(g.closest('[data-sb-section]') || g, '[data-sb-vslot]'), u = img && img.src;
const dir = (img && img.position || 0) >= (g._sbPos || 0) ? 1 : -1;
if (img) g._sbPos = img.position;
const swap = (x, src, slide) => {
x.removeAttribute('srcset');
if (!slide || reduced || !x.animate || x.src === src) { x.src = src; return; }
const pre = new Image();
pre.onload = pre.onerror = () => {
const box = x.parentElement, was = x.cloneNode(), t = { duration: 380, easing: 'cubic-bezier(.2,.7,.2,1)' };
if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
box.style.overflow = 'hidden';
was.style.cssText += ';position:absolute;inset:0;width:100%;height:100%;object-fit:cover;pointer-events:none';
box.appendChild(was);
x.src = src;
x.animate([{ transform: 'translateX(' + dir * 100 + '%)' }, { transform: 'none' }], t);
was.animate([{ transform: 'none' }, { transform: 'translateX(' + -dir * 100 + '%)' }], t).onfinish = () => was.remove();
};
pre.src = src;
};
if (vs.length && u) vs.forEach((e) => {
all(e, 'img').forEach((x) => swap(x, u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=1200', e.hasAttribute('data-sb-slide')));
[e].concat(all(e, '[data-lb-src]')).forEach((x) => { if (x.hasAttribute('data-lb-src')) x.setAttribute('data-lb-src', u); });
if (media) e.setAttribute('data-sb-media-id', String(media));
});
let k = media ? firstOf(slides, (s) => attr(s, 'data-sb-media-id') === String(media)) : -1;
if (k < 0 && img && img.id) k = firstOf(slides, (s) => attr(s, 'data-sb-image-id') === String(img.id));
if (k < 0 && img && img.src) k = firstOf(slides, (s) => { const x = s.querySelector('img'); return !!x && fileOf(x.currentSrc || x.src) === fileOf(img.src); });
if (k >= 0) go(k, true);
};
mark(0);
settle();
};
const carousel = (track) => {
if (track._sbGallery || track.closest('[data-sb-gallery]') || !once(track, 'Carousel')) return;
const root = track.closest('[data-sb-carousel]');
if (!root) return;
const own = (el) => el.closest('[data-sb-carousel]') === root;
const prev = all(root, '[data-sb-prev]').filter(own), next = all(root, '[data-sb-next]').filter(own);
const ends = () => {
const max = track.scrollWidth - track.clientWidth, x = Math.abs(track.scrollLeft), none = max <= 2;
prev.forEach((b) => { b.disabled = none || x <= 2; });
next.forEach((b) => { b.disabled = none || x >= max - 2; });
flag(root, 'data-sb-static', none);
root.style.setProperty('--sb-seen', (track.scrollWidth ? Math.min(1, track.clientWidth / track.scrollWidth) : 1).toFixed(4));
root.style.setProperty('--sb-progress', none ? '0' : Math.min(1, x / max).toFixed(4));
};
const step = (d) => () => {
const items = Array.prototype.filter.call(track.children, (el) => el.offsetWidth > 0);
const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
const w = items[0] ? items[0].getBoundingClientRect().width + gap : track.clientWidth;
track.scrollBy({ left: d * Math.max(1, Math.floor((track.clientWidth + gap) / w)) * w, behavior: behavior });
};
click(prev, step(-1));
click(next, step(1));
const later = throttle(ends, 60);
track.addEventListener('scroll', later, { passive: true });
track.addEventListener('load', later, true);
if (window.ResizeObserver) new ResizeObserver(later).observe(track);
else window.addEventListener('resize', later);
ends();
};
let pageLoaded = doc.readyState === 'complete';
const afterLoad = [];
const whenLoaded = (fn) => { if (pageLoaded) fn(); else afterLoad.push(fn); };
window.addEventListener('load', () => {
pageLoaded = true;
const run = () => afterLoad.splice(0).forEach((fn) => fn());
if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 2000 }); else setTimeout(run, 200);
});
const video = (v) => {
if (!once(v, 'Video')) return;
v.muted = v.defaultMuted = v.loop = v.playsInline = true;
['muted', 'playsinline', 'loop'].forEach((a) => v.setAttribute(a, ''));
v.removeAttribute('autoplay');
v.autoplay = false;
const box = v.closest('[data-sb-video]') || v.parentElement;
const btn = box && box.querySelector('[data-sb-play]');
let manual = reduced, wanted = false, near = false;
const sync = () => { if (btn) show(btn, manual && v.paused); };
const poster = () => { const p = attr(v, 'data-sb-poster'); if (p) { v.poster = p; v.removeAttribute('data-sb-poster'); } };
const warm = () => { if (near && !manual && attr(v, 'preload') === 'none') v.setAttribute('preload', 'auto'); };
const play = () => {
v.muted = true;
poster();
const p = v.play();
if (p && p.catch) p.catch((e) => { if (e && (e.name === 'NotAllowedError' || e.name === 'NotSupportedError')) { manual = true; sync(); } });
};
if (btn) click([btn], () => { wanted = true; play(); });
v.addEventListener('play', sync);
v.addEventListener('pause', sync);
v.addEventListener('click', () => {
if (!manual) return;
wanted = v.paused;
if (wanted) play(); else v.pause();
});
if (manual) v.pause();
whenLoaded(poster);
if ('IntersectionObserver' in window) {
new IntersectionObserver((entries) => entries.forEach((e) => {
near = e.isIntersecting;
if (near) { poster(); whenLoaded(warm); }
}), { rootMargin: '50% 0px' }).observe(v);
new IntersectionObserver((entries) => entries.forEach((e) => {
const seen = e.isIntersecting && e.intersectionRatio >= 0.4;
if (seen && (!manual || wanted)) play();
else if (!seen && !v.paused) v.pause();
}), { threshold: [0, 0.4, 0.6] }).observe(v);
} else { poster(); if (!manual) play(); }
sync();
};
const reviews = (el) => {
if (!once(el, 'Reviews')) return;
const root = el.closest('[data-sb-reviews-root]') || el;
const list = root.querySelector('[data-sb-reviews-list]'), tpl = root.querySelector('template[data-sb-review]');
const more = root.querySelector('[data-sb-reviews-more]'), box = root.querySelector('[data-sb-reviews-summary]');
let base = null;
try { base = new URL(attr(el, 'data-sb-reviews-endpoint'), location.href); } catch (e) {}
if (!list || !tpl || !base || !/^https?:$/.test(base.protocol)) { root.hidden = true; return; }
const per = Math.max(1, parseInt(attr(el, 'data-sb-reviews-per'), 10) || 6), handle = attr(el, 'data-sb-reviews-product');
let page = 1, next = null, remote = false, busy = false, shown = 0, items = [];
const safe = (u) => { try { const x = new URL(u, base); return /^https?:$/.test(x.protocol) ? x.href : null; } catch (e) { return null; } };
const stars = (f, rating) => {
f.style.setProperty('--sb-rating', String(rating));
f.style.setProperty('--sb-fill', Math.max(0, Math.min(100, rating * 20)) + '%');
f.setAttribute('data-rating', String(rating));
f.setAttribute('role', 'img');
f.setAttribute('aria-label', words(f, 'data-label', { rating: String(rating) }) || rating + ' / 5');
};
const put = (node, r) => all(node, '[data-field]').forEach((f) => {
const k = attr(f, 'data-field');
let val = '';
if (k === 'rating') return stars(f, Math.max(0, Math.min(5, Number(r.rating) || 0)));
if (k === 'verified') return show(f, !!r.verified);
if (k === 'photos') {
const urls = (Array.isArray(r.photos) ? r.photos : []).map((x) => safe(typeof x === 'string' ? x : x && (x.url || x.src))).filter(Boolean).slice(0, 4);
urls.forEach((u) => { const img = doc.createElement('img'); img.src = u; img.alt = attr(f, 'data-alt') || ''; img.loading = 'lazy'; img.decoding = 'async'; f.appendChild(img); });
return show(f, urls.length > 0);
}
if (k === 'date') {
const d = r.date ? new Date(r.date) : null;
if (d && !isNaN(d.getTime())) {
val = d.toLocaleDateString(doc.documentElement.lang || undefined, { year: 'numeric', month: 'short', day: 'numeric' });
if (f.tagName === 'TIME') f.dateTime = d.toISOString().slice(0, 10);
}
} else val = r[k] == null ? '' : String(r[k]).trim();
if (val) f.textContent = val; else f.hidden = true;
});
const summary = (rating, count) => {
rating = Number(rating);
count = Number(count);
if (!box) return;
const ok = rating > 0 && count > 0;
show(box, ok);
if (ok) all(box, '[data-field]').forEach((f) => {
const k = attr(f, 'data-field');
if (k === 'rating') stars(f, rating);
else if (k === 'average') setText(f, (Math.round(rating * 10) / 10).toFixed(1));
else if (k === 'count') setText(f, words(f, 'data-label', { count: count.toLocaleString() }) || count.toLocaleString());
});
};
const url = () => {
if (next) return next;
const u = new URL(base.href);
if (handle) u.searchParams.set('product', handle);
u.searchParams.set('page', String(page));
u.searchParams.set('per', String(per));
return u.href;
};
const load = () => {
busy = true;
if (more) more.disabled = true;
const done = () => { busy = false; if (more) more.disabled = false; };
return fetch(url(), { headers: { Accept: 'application/json' } }).then((res) => {
if (!res.ok) throw new Error(String(res.status));
return res.json();
}).then((data) => {
data = data || {};
const got = (Array.isArray(data.reviews) ? data.reviews : []).filter((r) => r && (r.body || r.title) && Number(r.rating) > 0);
items = items.concat(got);
next = typeof data.next === 'string' && data.next ? safe(data.next) : null;
remote = got.length > 0 && !!(next || data.hasMore || Number(data.pages) > Number(data.page || page));
page += 1;
const sum = data.summary || {};
summary(sum.rating != null ? sum.rating : data.average, sum.count != null ? sum.count : data.total);
done();
}, (err) => { done(); throw err; });
};
const render = () => {
const end = Math.min(items.length, shown + per);
for (; shown < end; shown++) { const node = tpl.content.cloneNode(true); put(node, items[shown]); list.appendChild(node); }
if (more) show(more, shown < items.length || remote);
root.hidden = shown === 0;
};
if (more) click([more], () => {
if (busy) return;
if (shown < items.length) render();
else if (remote) load().then(render, () => { more.hidden = true; });
});
load().then(render, () => { root.hidden = true; });
};
const tabs = (root) => {
if (!once(root, 'Tabs')) return;
const mine = (sel) => all(root, sel).filter((el) => el.closest('[data-sb-tabs]') === root);
const bs = mine('[data-sb-tab]'), ps = mine('[data-sb-panel]');
if (!bs.length || !ps.length) return;
bs[0].parentElement.setAttribute('role', 'tablist');
const key = (el) => attr(el, 'data-sb-tab') || attr(el, 'data-sb-panel');
const select = (k, focus) => {
bs.forEach((b) => { const on = key(b) === k; b.setAttribute('aria-selected', on); b.tabIndex = on ? 0 : -1; b.classList.toggle('is-active', on); if (on && focus) b.focus(); });
ps.forEach((p) => { const on = key(p) === k; show(p, on); p.classList.toggle('is-active', on); });
root.setAttribute('data-sb-active', k);
root.style.setProperty('--sb-active-index', firstOf(bs, (b) => key(b) === k));
root.style.setProperty('--sb-tab-count', bs.length);
window.dispatchEvent(new Event('resize'));
};
bs.forEach((b, n) => {
b.setAttribute('role', 'tab');
b.addEventListener('click', (e) => { e.preventDefault(); select(key(b)); });
b.addEventListener('keydown', (e) => {
const d = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
if (d) { e.preventDefault(); select(key(bs[(n + d + bs.length) % bs.length]), true); }
});
});
ps.forEach((p) => p.setAttribute('role', 'tabpanel'));
select(key(bs[Math.max(0, firstOf(bs, (b) => attr(b, 'aria-selected') === 'true'))]));
};
const style = () => {
if (doc.getElementById('sb-commerce-css')) return;
const s = doc.createElement('style');
s.id = 'sb-commerce-css';
s.textContent = '[data-sb-track]{scrollbar-width:none;-ms-overflow-style:none}[data-sb-track]::-webkit-scrollbar{display:none}' +
':where([data-sb-track]){overflow-x:auto;overscroll-behavior-x:contain;-webkit-overflow-scrolling:touch}' +
['compare', 'save', 'unit-price', 'total', 'stock', 'express', 'play', 'value-price', 'value-compare', 'value-save', 'value-unit-price', 'reviews-root', 'reviews-summary', 'reviews-more', 'panel']
.map((k) => '[data-sb-' + k + '][hidden]').join(',') + ',[data-sb-reviews-list] [hidden]{display:none!important}' +
'[data-sb-sticky]:not(.is-visible){opacity:0;pointer-events:none}';
(doc.head || doc.documentElement).appendChild(s);
};
const guard = (fn) => (el) => { try { fn(el); } catch (e) { if (window.console) console.error('sb-commerce', e); } };
const init = () => {
style();
const pick = (sel) => all(doc, sel).filter(ours);
pick('form[data-sb-buy]').forEach(guard(buy));
pick('[data-sb-tabs]').forEach(guard(tabs));
pick('[data-sb-gallery]').forEach(guard(gallery));
pick('[data-sb-track]').forEach(guard(carousel));
pick('video[data-sb-autoplay]').forEach(guard(video));
pick('[data-sb-sticky]').forEach(guard(sticky));
pick('[data-sb-reviews-endpoint]').forEach(guard(reviews));
};
doc.addEventListener('toggle', (e) => {
const d = e.target;
if (!d || d.tagName !== 'DETAILS' || !d.open || !d.hasAttribute('data-sb-accordion') || !ours(d)) return;
const group = d.parentElement && d.parentElement.closest('[data-sb-single]');
if (group) all(group, 'details[data-sb-accordion][open]').forEach((o) => { if (o !== d && o.parentElement.closest('[data-sb-single]') === group) o.open = false; });
}, true);
window.addEventListener('pageshow', () => all(doc, 'form[data-sb-buy]').forEach((f) => { if (f._sbReset) f._sbReset(); }));
doc.addEventListener('shopify:section:load', () => init());
window.SBCommerce = { init: init, money: money, version: 1 };
if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
else init();
})();
